(($, Drupal, drupalSettings) => {
  Drupal.behaviors.wwf_before_after_slider = {
    attach(context, settings) {
      const sliders = once(
        "wwf_image_reveal_slider",
        ".wwf_image_reveal--slider",
        context
      );
      sliders.forEach((slider) => {
        $(slider).twentytwenty({
          default_offset_pct: `0.${
            settings.wwf_image_reveal[slider.attributes.id.value].options
              .starting_percentage
          }`,
          before_label: "",
          after_label: "",
          no_overlay: true,
        });
      });
      $(window).on("load", function () {
        $(window).trigger("resize.twentytwenty");
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
